module.exports = __webpack_public_path__ + "img/catarata.99929b15.png";